@if (railMenu; as entries) {
  <app-rail-menu
    [entries]="entries"
    [submenus]="{ 'new-item': newNoteForm, 'new-container': newNotebookForm }"
    (selected)="runRailEntry($event)"
  />
  <ng-template #newNoteForm>
    <app-note-quick-form
      class="quick-form"
      [note]="railNewNote"
      [tenantItems]="[railNewNote]"
      [autofocus]="true" [showMore]="true" [showCancel]="true" [inline]="true"
      (close)="handleClose()"
      (more)="handleQuickDetails($event)"
    />
  </ng-template>
  <ng-template #newNotebookForm>
    <app-notebook-quick-form
      class="quick-form"
      [notebook]="railNewNotebook"
      [tenantItems]="[railNewNotebook]"
      [autofocus]="true" [showMore]="true" [showCancel]="true" [inline]="true"
      (close)="handleClose()"
    (more)="handleQuickDetails($event)" />
  </ng-template>
} @else {
@if (sidebarFilterKey === 'following') {
  <app-context-menu-item title="Clear my subscriptions" [close]="true" (execute)="clearMySubscriptions()" />
}
@if ((isTeamRail && sidebarFilterKey === 'all_notebooks') || !(['all_notebooks', 'deleted', 'archived'] | includesBy: sidebarFilterKey)) {
  <app-context-menu-item
    title="Add new note"
    >
    <app-note-quick-form
      class="quick-form"
      [note]="stitchItem"
      [tenantItems]="[stitchItem]"
      [autofocus]="true" [showMore]="true" [showCancel]="true" [inline]="true"
      (close)="handleClose()"
      (more)="handleQuickDetails($event)"
      />
    </app-context-menu-item>
  }

  @if ((isTeamRail && sidebarFilterKey === 'all_notes') || !(['all_notes', 'deleted', 'archived'] | includesBy: sidebarFilterKey)) {
    <app-context-menu-item
      title="Add new notebook"
      >
      <app-notebook-quick-form
        class="quick-form"
        [notebook]="containerStitchItem"
        [tenantItems]="[containerStitchItem]"
        [autofocus]="true" [showMore]="true" [showCancel]="true" [inline]="true"
        (close)="handleClose()"
        (more)="handleQuickDetails($event)" />
      </app-context-menu-item>
    }

    @if (!(['all_notes', 'deleted', 'archived', 'all_notebooks'] | includesBy: sidebarFilterKey)) {
      <app-context-menu-divider
        />
    }

    @if (sidebarFilterKey === 'flagged') {
      <app-context-menu-item
        title="Unflag all"
        [close]="true"
        (execute)="unFlagAll()"
        />
    }

    @if (sidebarFilterKey === 'followed') {
      <app-context-menu-item
        [title]="followUpWording.removeAllFollowUps()"
        [close]="true"
        (execute)="unFollowAll()"
        />
    }

    @if (sidebarFilterKey === 'snoozed') {
      <app-context-menu-item
        title="Unsnooze all"
        [close]="true"
        (execute)="unSnoozeAll()"
        />
    }

    @if ((['followed', 'snoozed', 'flagged'] | includesBy: sidebarFilterKey)) {
      <app-context-menu-divider
        />
    }

    @if (sidebarFilterKey === 'archived') {
      <app-context-menu-item
        title="Delete all"
        [close]="true"
        (execute)="deleteAll()"
        />
    }

    @if (sidebarFilterKey === 'deleted') {
      <!--
        #1130 r2. Empty trash destroys BOTH notes and notebooks of this rail section's tenant, so it
        asks for both. "Delete all" above is a TRASH action despite its name (PATCH …/trash) and stays
        open to everyone in every workspace — the addendum of 2026-09-10 says so in as many words.

        The tenant asked is `purgeTenantId`, never the `tenantId` input: the private rail binds no tenant
        and the pipe refuses a nameless one, which disabled this entry for everyone there (#1143 F1).
      -->
      <app-context-menu-item
        title="Empty trash"
        [disabled]="!((purgeTenantId | appCanPurge: 'Note') && (purgeTenantId | appCanPurge: 'Notebook'))"
        [note]="PURGE_REFUSED_REASON"
        [matTooltip]="
          (purgeTenantId | appCanPurge: 'Note') && (purgeTenantId | appCanPurge: 'Notebook') ? '' : PURGE_REFUSED_REASON
        "
        [close]="true"
        (execute)="emptyTrash()"
        />
    }

    @if (rail) {
      <app-context-menu-item title="View settings…" [close]="true" (execute)="openRowViewSettings()" />
    } @else if (!(['deleted', 'archived'] | includesBy: sidebarFilterKey)) {
      <app-context-menu-item
        title="Settings"
        [close]="true"
        (execute)="openSettings()"
        />
    }
}
